"use client";

import NextError from "next/error";
import { useEffect } from "react";
import {
  fireAndForgetAppLog,
  getBrowserAppLogContext,
} from "@/lib/api/services/app_logs.client";
import { getAppLogErrorDetails } from "@/lib/utils/app-log-error";

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    console.error(error);

    const path = `${window.location.pathname}${window.location.search}`;
    const errorDetails = getAppLogErrorDetails(error, {
      name: "GlobalError",
      message: `Global error on ${path}`,
      digestParts: ["global_error", error.name, path, error.digest],
    });

    fireAndForgetAppLog({
      ...getBrowserAppLogContext(),
      level: "fatal",
      event_type: "global_error",
      source: "global-error.tsx",
      status_code: 500,
      ...errorDetails,
      fingerprint: `global_error:${errorDetails.error_name}:${path}:${errorDetails.error_digest}`,
      tags: ["react-error-boundary", "next-app-router", "fatal"],
      metadata: {
        component: "GlobalError",
      },
    });
  }, [error]);

  return (
    <html lang="en">
      <body>
        <NextError statusCode={500} />
      </body>
    </html>
  );
}
